module.exports = __webpack_public_path__ + "img/premios-marcos-katz-halpern.ea5a5436.jpg";